export default "__VITE_ASSET__swFGBbPD__"